var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts__container"},[_c('div',{staticClass:"texts"},[_c('h2',{staticClass:"center"},[_vm._v(_vm._s(_vm.$t('contacts.title1')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }